import React from 'react';

// Utils
import { MESSAGES } from '~/utils/message.js';

// MUI Component
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Icons
import {
  DetailsCrossCIcon,
  ExportModalCIcon,
  ModalCrossCIcon,
  ModalOrderCrossCIcon,
} from '~/assets/images';

// Styles
import './styles.scss';
import Mode from '~/components/Mode';
import OlcButton from '~/components/General/OlcButton';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ConfirmDialog = (props) => {
  const {
    successButtonName,
    heading,
    subMessage,
    message,
    icon,
    currentAction,
    loading,
    loaderColor,
    isExport = false,
  } = props.dialog;
  const { handleOk, handleClose, open } = props;
  return (
    <>
      <BootstrapDialog
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className={`orderautoFundModalWrapper ${currentAction === 'mode_modal' ? 'mode_modal_wrapper' : ''} ${currentAction === 'cancel' || currentAction === 'remove' || currentAction === 'payAndProcess' || currentAction === 'export' ? 'cancelOrderModal' : 'orderautoFundModalWrapper'}`}
      >
        <IconButton
          aria-label="close"
          className="confirmDialogCloseButton"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: { xs: 20, sm: 32 },
            top: 20,
            padding: '0',
            zIndex: 1000,
            color: (theme) => theme.palette.grey[500],
            transition: 'opacity 0.3s ease-in-out',
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: '0.4',
            },
          }}
        >
          <img src={ModalOrderCrossCIcon} alt="icon" />
        </IconButton>
        <DialogContent className="autoFundModalContent">
          {isExport ? (
            <ExportModalCIcon fill="#ed5c2f" />
          ) : (
            icon && (
              <Box className={`mainImg ${currentAction === 'cancel' ? 'cancelImg' : ''}`}>
                <img
                  style={
                    currentAction === 'mode_modal'
                      ? { width: '70px', height: '70px' }
                      : currentAction === 'payAndProcess'
                        ? { width: '40px', height: '40px' }
                        : null
                  }
                  src={icon}
                  alt=""
                />
              </Box>
            )
          )}
          <Box className="autoFundHeader">
            <Typography gutterBottom variant="h4">
              {heading}
            </Typography>
          </Box>
          <Box className="amountInputWrapper">
            <Typography className="boldTxt">{message}</Typography>
            <Typography className={`txt ${currentAction === 'cancel' ? 'cancelTxt' : ''}`}>
              {subMessage}
            </Typography>
          </Box>
          {currentAction === 'mode_modal' && (
            <Box className="modeModalToggleContainer">
              <Mode tooltipPlacement="above" />
            </Box>
          )}

          <Box className="autoFundModalBtns">
            <OlcButton variant="secondary" onClick={handleClose}>
              {currentAction === 'cancel' ? 'No' : MESSAGES.ACCOUNT.WALLET.STRIPE.CANCEL}
            </OlcButton>
            <OlcButton variant="primary" disabled={loading} onClick={loading ? null : handleOk}>
              {loading ? (
                <CircularProgress
                  sx={{
                    color: loaderColor || (currentAction === 'publish' ? '#ed5c2f' : 'white'),
                    width: '25px !important',
                    height: '25px !important',
                  }}
                />
              ) : successButtonName ? (
                successButtonName
              ) : (
                'Ok'
              )}
            </OlcButton>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

export default ConfirmDialog;
